// extracted by mini-css-extract-plugin
export default {"main":"Layout_main__FV28D","stickyContainer":"Layout_stickyContainer__A4k3R","layout":"Layout_layout__+nPRX"};